module.exports = __webpack_public_path__ + "static/media/logo.692aa4c1.svg";